export enum VideoSource {
	LINK = 'Link',
	SCHEDULED_EVENT = 'ScheduledEvent',
	UPLOAD = 'Upload',
	UPLOAD_360 = 'Upload360',
	WEBEX = 'Webex',
	SCHEDULED_RECORDING = 'ScheduledRecording'
}
